// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--3cJwF";
export var modal__bg = "modal-module--modal__bg--ed6WR";
export var modal__close = "modal-module--modal__close--3ztQB";
export var modal__header = "modal-module--modal__header--2yyba";
export var modal__header__close = "modal-module--modal__header__close--SOu8y";
export var modal__content = "modal-module--modal__content--1rFzT";
export var small = "modal-module--small--WRPPi";